import { ActionTypes as types } from 'constants';
import { getFromDonationHistoryServiceApi, logError } from 'actions';
import { updateFetchAppError } from 'actions/setters/updateAppErrors';
import { Auth } from 'utils';

const log = { component: 'getDonationHistory' };

// eslint-disable-next-line max-len
export default (
  date = {},
  registerdDonationsOnly,
  _getFromDonationHistoryServiceApi = getFromDonationHistoryServiceApi,
  _logError = logError,
) => (dispatch, getState) => {
  const {
    next,
    date: { startDate, endDate },
    charityDonationsOnly,
  } = getState().app.donationHistory;

  const newDate =
    (date.startDate || date.endDate || registerdDonationsOnly !== undefined) &&
    (date.startDate !== startDate ||
      date.endDate !== endDate ||
      (registerdDonationsOnly !== undefined &&
        registerdDonationsOnly !== charityDonationsOnly));

  dispatch({
    type: types.FETCH_DONATION_HISTORY,
    payload: {
      clearData: newDate,
    },
  });

  const startDateFormat = 'YYYY-MM-DDT00:00:00';
  const endDateFormat = 'YYYY-MM-DDT23:59:59';

  const dateString = newDate
    ? `${
        date.startDate
          ? `&StartDate=${date.startDate.format(startDateFormat)}`
          : ''
      }
    ${date.endDate ? `&EndDate=${date.endDate.format(endDateFormat)}` : ''}`
    : '';

  const donationHistoryResource =
    newDate || !next
      ? `/v1/donors/${Auth.getUserGuid()}/donations/history?Take=10${dateString}&CharityDonationsOnly=${
          registerdDonationsOnly ? 'True' : 'False'
        }`
      : next;
  return dispatch(_getFromDonationHistoryServiceApi(donationHistoryResource))
    .then(([res, json]) => {
      if (res.ok) {
        dispatch({
          type: types.FETCH_DONATION_HISTORY_SUCCESS,
          payload: {
            ...json,
            date,
            charityDonationsOnly: registerdDonationsOnly,
            clearData: newDate,
          },
        });
        // dispatch(initialize(forms.Notifications, json));
      } else if (json && json.Errors && json.Errors.length > 0) {
        const error = json.Errors[0].ErrorMessage;
        dispatch(updateFetchAppError());
        dispatch({ type: types.FETCH_DONATION_HISTORY_FAILURE });
        dispatch(
          _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, error }),
        );
      } else {
        dispatch(updateFetchAppError());
        dispatch({ type: types.FETCH_DONATION_HISTORY_FAILURE });
        dispatch(
          _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, res }),
        );
      }
    })
    .catch(error => {
      dispatch(updateFetchAppError());
      dispatch({ type: types.FETCH_DONATION_HISTORY_FAILURE });
      dispatch(
        _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, error }),
      );
    });
};
